module["exports"] = ["#{city_prefix}#{city_suffix}"];